<template>
  <Drawer
    :drawer="drawer"
    title="价格设置"
    :withHeader="true"
    :size="740"
    :wrapperClosable="false"
    @close="close"
  >
    <div class="content">
      <div class="opt">
        <!-- <el-select v-model="type" style="width: 120px" clearable @change="getList()">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->
        <el-button type="primary" style="margin-left: 20px; background: #1258bc" icon="el-icon-circle-plus-outline" @click="priceRowData = {}; dialogVisible = true"></el-button>
      </div>
      <BaseTable
        style="margin-top: 20px"
        :height="500"
        :isPager="false"
        :tableData="tableData"
        :loading="loading"
        :isEmptyBorder="false"
      >
        <template slot="opt" slot-scope="row">
          <el-button type="text" @click="priceRowData = row.scope; dialogVisible = true">修改</el-button>
          <el-button type="text" @click="deleteRow(row.scope)">删除</el-button>
        </template>
      </BaseTable>
    </div>
    <AddPriceDialog :dialogVisible="dialogVisible" :rowData="priceRowData" :tplType="tplType" :summaryId="rowData.id" @cancel="dialogVisible = false" @ok="dialogVisible = false; getList()"></AddPriceDialog>
  </Drawer>
</template>
<script>
import Drawer from './Drawer'
import {
  arApTemplateList,
//   saveArApTemplate,
  deleteArApTemplate
} from '@/api/fee'
const BaseTable = () => import('@/components/table/BaseTable')
import AddPriceDialog from '../dialog/AddPriceDialog'
export default {
  components: {
    Drawer,
    BaseTable,
    AddPriceDialog
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tplType: {
      type: Number,
      default: 0 // 0 客户 1 供应商
    }
  },
  data() {
    return {
    //   type: '',
    //   typeOptions: [
    //     { label: '应收', value: 0 },
    //     { label: '应付', value: 1 }
    //   ],
      tableData: {
        fileds: [
        //   {
        //     filed: 'typeName',
        //     label: '费用类型',
        //     width: '150px'
        //   },
          {
            filed: 'feeType',
            label: '费用大类',
            width: '150px'
          },
          {
            filed: 'feeName',
            label: '费用细类',
            width: '150px'
          },
          {
            filed: 'amount',
            label: '金额',
            width: '150px'
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '150px'
          },
          {
            filed: 'createdName',
            label: '创建人',
            width: '150px'
          },
          {
            filed: 'opt',
            label: '操作',
            width: '120px',
            fixed: 'right',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      loading: false,
      dialogVisible: false,
      priceRowData: {}
    }
  },
//   computed: {
//     summaryId
//   },
  watch: {
    drawer(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await arApTemplateList({
          companyId: !this.tplType ? this.rowData.id : undefined,
          supplierId: this.tplType ? this.rowData.id : undefined,
          type: this.type !== '' ? this.type : undefined
        })
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    close() {
      this.$emit('close')
    },
    deleteRow(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(async() => {
            try {
                const res = await deleteArApTemplate({
                    id: row.id
                })
                if (res.success) {
                    this.$message.success('删除成功')
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            } catch (error) {
                console.log(error)
            }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
    .content {
        width: 100%;
        padding: 20px;
        height: 100%;
        box-sizing: border-box;
        .opt {
            display: flex;
            justify-content: flex-end
        }
    }
</style>
